import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getDatabase, ref as dbRef, update } from "firebase/database";

function DailyReport() {
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [selectedGender, setSelectedGender] = useState('Total Staff');

const [attendanceData, setAttendanceData] = useState([]);
const udiseNumber = localStorage.getItem("udiseNumber");
const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const navigate = useNavigate();

     useEffect(() => {
        const storedLanguage = localStorage.getItem('language') || 'English';
        setLanguage(storedLanguage);
      }, []);


  // Fetch attendance data based on selected UDISE number
 useEffect(() => {
  const fetchAttendanceData = async () => {
    if (udiseNumber) {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data) {
          const attendanceArray = Object.keys(data).map(key => ({
            mobile: key,
            name: data[key].Name,
          }));
          setAttendanceData(attendanceArray);
        }
      } catch (error) {
        console.error('Error fetching attendance data:', error);
      }
    }
  };
  fetchAttendanceData();
}, [udiseNumber]);

  useEffect(() => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData.json`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data) {

          setEmployeeDetails(data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [udiseNumber]);

  useEffect(() => {
    const fetchAttendanceData = async () => {
  
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
  
      try {
        const response = await fetch(url);
        const data = await response.json();
  
        if (data) {
          const attendanceArray = Object.keys(data).map(key => ({
            mobile: key,
            name: data[key].Name,
          }));
          
          // Log the fetched data to the console
          console.log('Fetched Attendance Data:', attendanceArray);
  
          setAttendanceData(attendanceArray);
        }
      } catch (error) {
        console.error('Error fetching attendance data:', error);
      }
    };
  
    fetchAttendanceData();
  }, [udiseNumber]); // No dependencies, runs once on mount


 

  const handleGenderChange = (event) => {
    const gender = event.target.value;
    setSelectedGender(gender);
    
    if (udiseNumber && gender === 'Male Staff') {
    
      const fetchMaleStaff = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
        
        try {
          const response = await fetch(url);
          const data = await response.json();
        
          if (data) {
            const maleStaff = Object.keys(data).filter(mobile => data[mobile]?.Personaldetails?.Gender === 'Male');
            console.log("maleStaff", maleStaff);
        
            const maleStaffData = maleStaff.map(mobile => ({
              mobile,
              name: data[mobile].Name,
            }));
            setAttendanceData(maleStaffData);
          }
        } catch (error) {
          console.error('Error fetching male staff:', error);
        }
      };
    
      fetchMaleStaff();
    } else if (udiseNumber && gender === 'Female Staff') {
    
      const fetchFemaleStaff = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
        
        try {
          const response = await fetch(url);
          const data = await response.json();
        
          if (data) {
            const femaleStaff = Object.keys(data).filter(mobile => data[mobile]?.Personaldetails?.Gender === 'Female');
            const femaleStaffData = femaleStaff.map(mobile => ({
              mobile,
              name: data[mobile].Name,
            }));
            setAttendanceData(femaleStaffData);
          }
        } catch (error) {
          console.error('Error fetching female staff:', error);
        }
      };
    
      fetchFemaleStaff();
    } else if (udiseNumber && gender === 'Total Staff') {
      const fetchTotalStaff = async () => {
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;
        
        try {
          const response = await fetch(url);
          const data = await response.json();
        
          if (data) {
            const totalStaff = Object.keys(data).map(mobile => ({
              mobile: data[mobile].Mobno,
              name: data[mobile].Name,
            }));
            setAttendanceData(totalStaff);
          }
        } catch (error) {
          console.error('Error fetching total staff:', error);
        }
      };
    
      fetchTotalStaff();
    } else {
         
    }
  };

  const handleTotalStaffReport = () => {
    const totalStaffData = attendanceData.map(employee => ({
      mobile: employee.mobile,
      name: employee.name,
      gender: employeeDetails[udiseNumber]?.AttData[employee.mobile]?.Gender || 'Unknown',
    }));

    
console.log("totalStaffData",totalStaffData);

    navigate(`/total-staff-report?adminmob=${localStorage.getItem('adminmob')}&branchId=${udiseNumber}`, { state: { totalStaffData:attendanceData, udiseNumber } });
  };

  const handleAttendanceStaffReport = () => {
    navigate('/attendance-staff-report', {
      state: {
        adminmob: localStorage.getItem('adminmob'),
        branchId: udiseNumber,
      },
    });
  };

  const handleMaleStaffReport = () => {
    const maleStaffData = attendanceData.filter(employee =>
      employeeDetails[udiseNumber]?.AttData[employee.mobile] && employeeDetails[udiseNumber]?.AttData[employee.mobile].Personaldetails && employeeDetails[udiseNumber]?.AttData[employee.mobile].Personaldetails.Gender === 'Male'
    );
  
    navigate('/male-staff-report', { state: { maleStaffData } });
  };

  const handleFemaleStaffReport = () => {
    const femaleStaffData = attendanceData.filter(employee =>
      employeeDetails[udiseNumber]?.AttData[employee.mobile] && employeeDetails[udiseNumber]?.AttData[employee.mobile].Personaldetails && employeeDetails[udiseNumber]?.AttData[employee.mobile].Personaldetails.Gender === 'Female'
    );
  
    navigate('/female-staff-report', { state: { femaleStaffData } });
  };


  const getEmployeeDetailsForBranch = () => {
    if (!udiseNumber) return [];
  
    const employeesForBranch = employeeDetails[udiseNumber]?.EmployeeDetails || {};
  
    const filteredEmployees = Object.keys(employeesForBranch).filter(mobile => {
      if (selectedGender === 'Male Staff') {
        return employeesForBranch[mobile].Personaldetails && employeesForBranch[mobile].Personaldetails.Gender === 'Male';
      } else if (selectedGender === 'Female Staff') {
        return employeesForBranch[mobile].Personaldetails && employeesForBranch[mobile].Personaldetails.Gender === 'Female';
      } else {
        return true;
      }
    });
  
    return filteredEmployees.map(mobile => ({
      mobile,
      name: employeesForBranch[mobile].Personaldetails && employeesForBranch[mobile].Personaldetails.Name || 'Unknown',
      adminmob: mobile,
    }));
  };

  const handleAddStaff = () => {
    // Implement the functionality to add staff if needed
  };

  const handleClose = () => {
    navigate(-1);
  };
  



return (
  <>
    <div className="main-content-of-page" style={{ backgroundColor: '#f4f4f4', minHeight: '100vh', padding: '20px' }}>
      <div className="Dailyreport-container" style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', backgroundColor: '#ffffff', borderRadius: '10px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif', textAlign: 'center',border:'1px solid black' }}>
        <button style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '20px', marginLeft: '650px', fontWeight: 'bold' }} onClick={handleClose}>
          X
        </button>
        <h1 style={{ color: '#2c3e50', fontSize: '30px' }}> {language === "English" ? " Daily Report  " : "दैनिक अहवाल"}</h1>

        <div style={{ border: '1px solid black', marginTop: '10px', borderRadius: '6px' }}>
          

          <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
           
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* Total Staff Button */}
              <select className='me-3'
                style={{
                  borderRadius: '6px',
                  width: '150px',
                  border: '1px solid black',
                  height: '48px',
                  color: 'white',
                  backgroundColor: '#03365e',
                  marginBottom: '10px',
                  textAlign:'center'
                }}
                onChange={handleGenderChange} value={selectedGender}
              >
                <option value="Total Staff"> {language === "English" ? "Total Staff" : "एकूण कर्मचारी "}</option>
                <option value="Male Staff"> {language === "English" ? "Male Staff" : "पुरुष कर्मचारी"}</option>
                <option value="Female Staff">{language === "English" ? "Female Staff" : "महिला कर्मचारी"}</option>
              </select>

              {/* Dropdown for Report Selection */}
              <select 
                style={{
                  color: 'white',
                  backgroundColor: '#03365e',
                  borderRadius: '6px',
                  border: '1px solid black',
                  padding: '10px 20px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  width: '200px',
                  marginBottom: '10px',
                  marginLeft: '10px' // Adjust margin as needed
                }}
                onChange={(e) => {
                  switch (e.target.value) {
                    case 'Total Staff Report':
                      handleTotalStaffReport();
                      break;
                    case 'Attendance Staff Report':
                      handleAttendanceStaffReport();
                      break;
                    case 'Male Staff Report':
                      handleMaleStaffReport();
                      break;
                    case 'Female Staff Report':
                      handleFemaleStaffReport();
                      break;
                    case 'Date Of Joining Report':
                      navigate('/date-of-join-report', {
                        state: {
                          adminmob: localStorage.getItem('adminmob'),
                          branchId: udiseNumber,
                          employeeDetails: getEmployeeDetailsForBranch().map(employee => ({
                            empmobile: employee.adminmob,
                            empname: employee.name,
                          }))
                        },
                      });
                      break;
                    case 'Teacher Info Report':
                      navigate('/teacher-info-report', {
                        state: {
                          adminmob: localStorage.getItem('adminmob'),
                          branchId: udiseNumber,
                          employeeDetails: getEmployeeDetailsForBranch().map(employee => ({
                            empmobile: employee.mobile,
                            empname: employee.name,
                          })),
                        },
                      });
                      break;
                    default:
                      break;
                  }
                }}
              >
                <option value="">{language === "English" ? "Select Report" : "अहवाल निवडा"}</option>
                <option value="Total Staff Report">{language === "English" ? "Total Staff Report" : "एकूण कर्मचारी अहवाल"}</option>
                <option value="Attendance Staff Report">{language === "English" ? "Attendance Staff Report" : "उपस्थिती कर्मचारी अहवाल"}</option>
                <option value="Male Staff Report">{language === "English" ? "Male Staff Report" : "पुरुष कर्मचारी अहवाल"}</option>
                <option value="Female Staff Report">{language === "English" ? "Female Staff Report" : "महिला कर्मचारी अहवाल"}</option>
                <option value="Date Of Joining Report">{language === "English" ? "Date Of Join Report" : "रुजु झालेली तारीख"}</option>
                <option value="Teacher Info Report">{language === "English" ? "Staff Info Report" : "कर्मचारी माहिती अहवाल"}</option>

              </select>
            </div>
          </div>
        </div>

        <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid black', padding: '12px', textAlign: 'center', backgroundColor: '#03365e', color: 'white' }}>{language === "English" ? "Sr.No " : "अनु. क्र."}</th>
              <th style={{ border: '1px solid black', padding: '12px', textAlign: 'center', backgroundColor: '#03365e', color: 'white' }}>{language === "English" ? "Mobile Number" : "मोबाईल नंबर"}</th>
              <th style={{ border: '1px solid black', padding: '12px', textAlign: 'center', backgroundColor: '#03365e', color: 'white' }}>{language === "English" ? "Staff's Name" : "कर्मचाऱ्याचे नाव"}</th>
            </tr>
          </thead>
          <tbody>
            {attendanceData.length > 0 ? (
              attendanceData.map((employee, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : 'white' }}>
                  <td style={{ border: '1px solid #bdc3c7', padding: '12px', textAlign: 'center' }}>{index + 1}</td>
                  <td style={{ border: '1px solid #bdc3c7', padding: '12px', textAlign: 'center' }}>
                    <Link to={`/view-attendance/${employee.mobile}?employeeName=${employee.name}`}>
                      {employee.mobile}
                    </Link>
                  </td>
                  <td style={{ border: '1px solid #bdc3c7', padding: '12px', textAlign: 'center' }}>
                    <Link to={`/view-attendance/${employee.mobile}?employeeName=${employee.name}`}>
                      {employee.name}
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: 'center', padding: '12px' }}>Please select a branch to see employee details.</td>
              </tr>
            )}
          </tbody>
        </table>
       
      </div>
    </div>
  </>
);
}

export default DailyReport;